export const GET_PURCHASE_INVOICE = `
query getPurchaseOrderList($input: PurchaseOrderListInput!, $skip: Float, $take: Float) {
  getPurchaseOrderList(
    input: $input
    skip: $skip
    take: $take
  ) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      purchaseStatus
      teamSalesId
      ttId
      tcustomer {
        id
        sapCustomerId
        address
        cccd
        storeName
        mainCustomer {
            id
        }
      }
      totalQ10Buy
      note
      marketPrice
      poId
      totalFinalPriceAcounting
      totalQ10Acounting
      finalPrice
      tpolicyType{
        id
        name
      }
      tpurchaseStatus{
        id
        name
      }
      tcustType{
        id
        name
      }
      tdocType{
        id
        name
      }
      tpurchaseOrderQ10{
        orderId
      }
      tpurchaseChilds{
        id
        tcustomer {
          id
          sapCustomerId
          address
          cccd
          storeName
          mainCustomer {
              id
          }
      }
      ttId
      finalPrice
      purchaseStatus
      totalQ10Buy
      note
      marketPrice
      poId
      policyType
      tpolicyType{
        id
        name
      }
      tpurchaseStatus{
        id
        name
      }
      tcustType{
        id
        name
      }
      tdocType{
        id
        name
      }
      }
      tpurchType{
        id
        name
      }
      tpurchaseDetails {
        id
        q10
        q10Accounting
        totalGoldWeightThread
        totalGoldWeightOfStool
        totalPriceAccounting
        finalPrice
        policyPrice
        unitPrice
        policyAfterDeductedPrice
        measureWeightThread
        measureWeightThreadAccounting
        lossWeightThread
        lossWeightThreadAccounting
        includeWeightThread
        includeWeightThreadAccounting
        totalWeightStoolAccounting
        totalWeightThreadAccounting
        tproduct {
          id
          name
          age
          collection
          commodityLine
          mrpId
          mrpName
          unit
          type
          urlImage
          urlImage1
          urlImage2
          urlImage3
          urlImage4
          urlImage5
          category
          ttype {
            id
            name
            note
            status
          }
          plantId
          createDate
          createId
          modifyId
          tstorageLocation {
            id
            unitPriceByInch
          }
        }
        createDate
        modifyDate
        createId
        modifyId
        tcreateUser {
          fullName
        }
        tmodifyUser {
          fullName
        }
      }
      tcreateUser{
        id
        fullName
      }
      createDate
      tmodifyUser{
        id
        fullName
      }
      modifyDate
    } 
  }
}`;

// export const GET_PURCHASE_INVOICE_BY_ID = `
// query GetPurchaseMByCustomer($input: PurchaseMByCustInput){
//     getPurchaseMByCustomer(where: $input){
//         pageInfo{
//             currentPage
//             hasNextPage
//             hasPreviousPage
//             itemsPerPage
//             totalItems
//             totalPages
//         }
//         items{
//             id
//             finalPrice
//             marketGoldPriceId
//             customerId
//             tpolicyType{
//                 id
//                 name
//             }
//             purchType
//             tpurchType{
//                 name
//             }
//             tdocType{
//                 name
//             }
//             tdeductType{
//                 name
//             }
//             tdeductType{
//                 name
//             }
//             tcustType{
//                 id
//                 name
//             }
//             totalQ10Surplus
//             totalQ10Sell
//             totalQ10Diff
//             tpurchaseOrderQ10{
//                 id
//                 torder{
//                     id
//                     dealPrice
//                     marketGoldPrice
//                 }
//             }
//             purchaseStatus
//             note
//             totalQ10Buy
//             finalPrice
//             marketPrice
//             createId
//             tcreateUser{
//                 fullName
//             }
//             createDate
//             modifyId
//             tmodifyUser{
//                 fullName
//             }
//             modifyDate
//             custType
//             tpurchaseDetails{
//                 id
//                 q10
//                 totalGoldWeightThread
//                 totalGoldWeightOfStool
//                 finalPrice
//                 policyPrice
//                 unitPrice
//                 policyAfterDeductedPrice
//                 measureWeightThread
//                 lossWeightThread
//                 includeWeightThread
//                 tproduct{
//                     id
//                     name
//                     age
//                     collection
//                     commodityLine
//                     mrpId
//                     mrpName
//                     unit
//                     type
//                     urlImage
//                     urlImage1
//                     urlImage2
//                     urlImage3
//                     urlImage4
//                     urlImage5
//                     category
//                     ttype{
//                         id
//                         name
//                         note
//                         status
//                     }
//                     plantId
//                     createDate
//                     createId
//                     modifyId
//                     tstorageLocation{
//                         id
//                         unitPriceByInch
//                     }
//                 }
//                 createDate
//                 modifyDate
//                 createId
//                 modifyId
//                 tcreateUser{
//                     fullName
//                 }
//                 tmodifyUser{
//                     fullName
//                 }
//             }
//         }
//     }
// }`;

export const GET_PURCHASE_INVOICE_BY_ID = `
query getPurchaseOrder($id: String!) {
  getPurchaseOrder(
    id: $id
  ) {
    code
    message
    success
    data {
      id
      createId
      matDoc
      matYear
      rematDoc
      rematYear
      reivDoc
      reivYear
      ivDoc
      ivYear
      ivStatus
      statusId
      purchaseType
      purchaseStatus
      marketGoldPriceId
      dealPrice
      totalQ10Sell
      totalQ10Surplus
      deductType
      customerCheckinId
      tcustomer {
        id
        sapCustomerId
        taxId
        address
        cccd
        storeName
      }
      tpurchaseOrderQ10{
        id
        torder{
          id
          dealPrice
          marketGoldPrice
        }
      }
      totalQ10Buy
      note
      marketPrice
      poId
      policyType
      tpolicyType{
        id
        name
      }
      tpurchaseStatus{
        id
        name
      }
      tcustType{
        id
        name
      }
      tdocType{
        id
        name
      }
      tpurchType{
        id
        name
      }
      tpurchaseChilds{
        id
      }
      tpurchaseDetails {
        id
        q10
        q10Accounting
        totalGoldWeightThread
        totalGoldWeightOfStool
        finalPriceAccounting
        finalPrice
        policyPrice
        unitPrice
        policyAfterDeductedPrice
        sloc
        measureWeightThread
        measureWeightThreadAccounting
        lossWeightThread
        lossWeightThreadAccounting
        includeWeightThread
        includeWeightThreadAccounting
        totalWeightStoolAccounting
        totalWeightThreadAccounting
        parentId
        tproduct {
          id
          name
          age
          collection
          commodityLine
          mrpId
          mrpName
          unit
          type
          urlImage
          urlImage1
          urlImage2
          urlImage3
          urlImage4
          urlImage5
          category
          ttype {
            id
            name
            note
            status
          }
          plantId
          createDate
          createId
          modifyId
          tstorageLocation {
            id
            unitPriceByInch
          }
        }
        createDate
        modifyDate
        createId
        modifyId
        tcreateUser {
          fullName
        }
        tmodifyUser {
          fullName
        }
      }
      tcreateUser{
        id
        fullName
      }
      createDate
      tmodifyUser{
        id
        fullName
      }
      modifyDate
      parentId
    }
  }
}`;

export const GET_PURCHASE_INVOICE_DEAL_PRICE = `
query GetPurchaseApprovalData($input:GetApprovalDataInput!){
    getPurchaseApprovalData(where:$input){
        salePrice
        dealPrice
        note
        statusId
        status
        usePolicyPrice
    }
}`;

export const PURCHASE_INVOICE_SEPARATION = `
mutation PurchaseOrderSeparation($id: String!, $amount: Float!) {
  purchaseOrderSeparation(id: $id, amount: $amount) {
    success
    code
    message
    data {
      id
      poId
      ttId
      purchaseType
      marketGoldPriceId
      marketPrice
      dealPrice
      totalQ10Sell
      totalQ10Buy
      totalQ10Surplus
      note
      createId
      custType
      customerId
      deductType
      docType
      policyType
      purchType
      createDate
      modifyId
      modifyDate
      tpurchaseDetails {
        id
        totalGoldWeightThread
        totalGoldWeightOfStool
        q10
        totalPrice
        finalPrice
        policyPrice
        policyAfterDeductedPrice
        createId
        createDate
        parentId
        statusId
        modifyId
        modifyDate
        tproduct {
          name
          id
        }
      }
    }
  }
}`;

export const CANCEL_PURCHASE_SEPARATION = `
mutation CancelPurchaseOrderSeparation($id: String!) {
  cancelPurchaseOrderSeparation(id: $id) {
    code
    success
    message
    data {
      id
      poId
      ttId
      purchaseType
      marketGoldPriceId
      marketPrice
      dealPrice
      totalQ10Sell
      totalQ10Buy
      totalQ10Surplus
      note
      createId
      custType
      customerId
      deductType
      docType
      policyType
      purchType
      createDate
      modifyId
      modifyDate
      tpurchaseDetails {
        id
        totalGoldWeightThread
        totalGoldWeightOfStool
        q10
        totalPrice
        finalPrice
        policyPrice
        policyAfterDeductedPrice
        createId
        createDate
        modifyId
        modifyDate
        tproduct {
          name
          id
        }
      }
    }
  }
}`;

export const CALCULATE_ITEM_SEPARATION_PRICE = `
query CalculateItemSeparationPrice($input: SeparationPurchaseOrderInput!) {
  calculateItemSeparationPrice(input: $input) {
    success
    code
    message
    data {
        measureWeightThread
        includeWeightThread
        lossWeightThread
        finalPrice
        q10
        totalPrice
        productId   
        tpurchase{
            marketPrice
            dealPrice
            custType
            policyType
            deductType
        }
    }
  }
}`;

export const PURCHASE_INVOICE_ITEM_SEPARATION = `
mutation PurchaseOrderItemSeparation($input: SeparationPurchaseOrderInput!) {
  purchaseOrderItemSeparation(input: $input) {
    success
    code
    message
    data {
      id
      measureWeightThread
        includeWeightThread
        lossWeightThread
        productId   
        tpurchase{
            marketPrice
            dealPrice
            custType
            policyType
            deductType
        }
    }
  }
}`;

export const CANCEL_PURCHASE_INVOICE_ITEM_SEPARATION = `
mutation CancelPurchaseOrderItemSeparation($id: String!, $detailId: String!) {
  cancelPurchaseOrderItemSeparation(id: $id, detailId: $detailId) {
    code
    success
    message
    data {
      totalGoldWeightThread
      totalGoldWeightOfStool
      q10
      totalPrice
      finalPrice
      policyPrice
      policyAfterDeductedPrice
      createId
      createDate
      modifyId
      modifyDate
      tproduct {
        name
        id
      }
    }
  }
}`;

export const GET_PURCHASE_INVOICE_SEPARATION = `
query GetPurchaseOrderSeparation($id: String!) {
  getPurchaseOrderSeparation(id: $id) {
    success
    code
    message
    data {
      id
      poId
      ttId
      purchaseType
      marketGoldPriceId
      marketPrice
      dealPrice
      totalQ10Sell
      totalQ10Buy
      totalQ10Surplus
      note
      createId
      custType
      customerId
      deductType
      docType
      policyType
      purchType
      createDate
      modifyId
      modifyDate
      tpurchaseDetails {
        id
        totalGoldWeightThread
        totalGoldWeightOfStool
        q10
        totalPrice
        finalPrice
        policyPrice
        policyAfterDeductedPrice
        createId
        statusId
        remainingFinalPrice
        remainingQ10
        remainingWeightStool
        remainingWeightThread
        parentId
        createDate
        modifyId
        modifyDate
        tproduct {
          name
          id
        }
      }
    }
  }
}`;

export const UPDATE_PURCHASE_ORDER_WEIGHT_FOR_ACCOUNTANT = `
mutation UpdatePurchaseOrderWeightForAccounting($data: UpdatePurchaseOrderWeightForAccountingInput!) {
  updatePurchaseOrderWeightForAccounting(input: $data) {
    success
    code
    message
   data {
      id
      poId
     
    }
  }
}`;

export const SAVE_PURCHASE_ORDER_SEPARATION = `
mutation SavePurchaseOrderSeparation($id: String!) {
  savePurchaseOrderSeparation(id: $id) {
    success
    code
    message
   data {
      id
      poId
      ttId
      purchaseType
      marketGoldPriceId
      marketPrice
      dealPrice
      totalQ10Sell
      totalQ10Buy
      totalQ10Surplus
      note
      createId
      custType
      customerId
      deductType
      docType
      policyType
      purchType
      createDate
      modifyId
      modifyDate
      tpurchaseDetails {
        id
        totalGoldWeightThread
        totalGoldWeightOfStool
        q10
        totalPrice
        finalPrice
        policyPrice
        policyAfterDeductedPrice
        totalAcEditWeightThread
        totalAcEditWeightOfStool
        createId
        createDate
        parentId
        statusId
        modifyId
        modifyDate
        tproduct {
          name
          id
        }
      }
    }
  }
}`;

export const GET_PURCHASE_INVOICE_MATERIALS = `
query GetProduct($input: TproductWhereInput, $skip: Float, $take: Float){
  getProduct(where: $input,skip: $skip, take: $take, orderBy:{createDate: DESC}) {
      pageInfo{
          currentPage
          hasNextPage
          hasPreviousPage
          itemsPerPage
          totalItems
          totalPages
      }
    items{
      id
      name
      age
      collection
      commodityLine
      mrpId
      mrpName
      unit
      type
      urlImage
      urlImage1
      urlImage2
      urlImage3
      urlImage4
      urlImage5
      category
      ttype{
          id
          name
          note
          status
      }
      plantId
      createDate
      createId
      modifyId
      tstorageLocation{
          id
      }
    }
  }
}`;

export const GET_TYPE_PURCHASE = `
query GetTypePurchase($input: TcodeWhereInput!){
    getCode(where: $input){
        items{
            id
            name
        }
    }
}
`;

export const GET_PURCHASE_STATUS_COMBOBOX = `
query GetStatusTeamSale($input: TcodeWhereInput!){
    getCode(where: $input){
        items{
            id
            name
        }
    }
}`;

export const GET_UNIT_PURCHASE = `
query GetTypeNeedSubtraction($input: TcodeWhereInput!){
    getCode(where: $input){
        items{
            id
            name
        }
    }
}
`;

export const GET_TYPE_POLICY_PURCHASE = `  
query GetTypePolicy($input: TcodeWhereInput!){
    getCode(where: $input){
        items{
            id
            name
        }
    }
}

`;

export const GET_TYPE_OF_DOC = `
query GetTypeOfDoc($input: TcodeWhereInput!){
    getCode(where: $input){
        items{
            id
            name
        }
    }
}

`;

export const GET_TYPE_CUSTOMER = `
query GetTypeCustomer($input: TcodeWhereInput!){
    getCode(where: $input){
        items{
            id
            name
        }
    }
}

`;

export const GET_MARKET_GOLD_PRICE = `
query GetMarketGoldPriceList($input:GetMarketGoldPriceInput!,$skip:Float,$take:Float){
    getDataMarketGoldPrice(where:$input,skip:$skip,take:$take){
        pageInfo {
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
            }
        items{
            id
            typeGold
            salePrice
            buyPrice
            createDate
            createId
            modifyDate
            modifyId
            conditionId
            conditionType
            keyTable
            salesOrg
            channel
            district
            plant
            customer
            custgroup
            age
            mcGroup
            productId
            amountGram
            pricingUnit
            unit
            validFromDate
            validToDate
            groupPrice
            modifyId
            updateOrigin
        }
    }
}`;

export const GET_MARKET_GOLD_PRICE_APPROVAL = `
query GetPurchaseApprovalData($input:GetApprovalDataInput!){
  getPurchaseApprovalData(where:$input){
      salePrice
      dealPrice
      note
      status
      statusId
      usePolicyPrice
  }
}`;

export const SAVE_PURCHASE_ORDER = `
mutation SavePurchaseOrder ($input: PurchaseOrderInput!) {
  savePurchaseOrder(
    input: $input
  ) {
      success
      code
      message
      data {
          id
          poId
          ttId
          parentId
          purchaseType
          marketGoldPriceId
          marketPrice
          dealPrice
          totalQ10Sell
          totalQ10Buy
          totalQ10Surplus
          purchaseStatus
          tpurchaseOrderQ10{
            id
            torder{
              id
              marketGoldPrice
              dealPrice
            }
          }
          note
          createId
          custType
          customerId
          customerCheckinId
          deductType
          docType
          policyType
          purchType
          createDate
          modifyId
          modifyDate
          tcreateUser{
              fullName
          }
          tmodifyUser{
              fullName
          }
          tpurchaseDetails {
              id
              q10
              unitPrice
              totalPrice
              finalPrice
              policyPrice
              totalGoldWeightThread
              totalGoldWeightOfStool
              policyAfterDeductedPrice
              totalAcEditWeightThread
              totalAcEditWeightOfStool
              includeWeightThread
              lossWeightThread
              measureWeightThread
                includeWeightThreadAccounting
              lossWeightThreadAccounting
              measureWeightThreadAccounting
              sloc
              totalWeightThreadAccounting
              q10Accounting
              totalWeightStoolAccounting
              finalPriceAccounting
              createId
              createDate
              modifyId
              tmodifyUser {
                fullName
              }
              modifyDate
              tproduct {
                  name
                  id
              }
          }
      }
  }
}`;

export const COMPLETE_PURCHASE_ORDER = `
mutation CompletePurchaseOrder($id: String!){
  completePurchaseOrder(id: $id){
      success
      code
      message
      data{
      id
      purchaseStatus
      policyType
      }
  }
}`;

export const CREATE_DEAL_PRICE = `
mutation CreateDealPrice($input:DealPriceInput!){
  createDealPrices(input:$input){
    id
    orderId
    salePrice
    usePolicyPrice
  }
}`;

export const MOVE_PURCHASE_INVOICE_ITEM = `
mutation MovePurchaseOrderItem($fromId: String!, $toId: String!, $detailId: String!) {
  movePurchaseOrderItem(fromId: $fromId, toId: $toId, detailId: $detailId) {
    success
    code
    message
    data {
      id
      totalGoldWeightThread
      totalGoldWeightOfStool
      q10
      totalPrice
      finalPrice
      policyPrice
      policyAfterDeductedPrice
      createId
      createDate
      modifyId
      modifyDate
      tproduct {
        name
        id
      }
    }
  }
}`;

export const ORDER_TEMP_ID_CBX = `
query getOrderTempIDCombobox($input:ViewSpecificOrderIdWhereInput ,$skip: Float, $take: Float ) {
  getIewSpecificOrderId(where: $input, skip: $skip, take: $take) {
    items{
        id
        dealPrice
        marketGoldPrice
        totalQ10
        customerId
       } 
  } 
}
`;

export const DELETE_PURCHASE = `
mutation DeletePurchaseOrder($id: String!){
    deletePurchaseOrder(id: $id){
        code
        success
        message
        data{
            id
        }
    }
}
`;
